import { HomeIcon } from 'asterX-UI/Icons/HomeIcon'
import { RopInfo } from '../../RopInfo/RopInfo'
import { WlList } from '../../WlList/WlList'
import { TasksList } from '../../TasksList/TasksList'

export const ropTabsList = [
  {
    icon: HomeIcon,
    component: RopInfo
  },
  {
    label: 'РЛ',
    component: WlList
  },
  {
    label: 'Задачи',
    component: TasksList
  }
]
